export enum Channel {
  SMS = 1,
  EMAIL = 2,
  API = 3
}

export enum OtpType {
  NUMBER = 1,
  TEXT = 2
}

//  export enum OtpStatus {
//   VERIFIED = 1,
//   EXPIRED = 2
// }

export interface IConfigureOtp {
  senderId?: string;
  originatingEmail?: string;
  deleveryChannels: Channel[];
  customerificationMessage: string;
  otpType: OtpType;
  expiresTime: number;
  otpLenght: number;
  subject?: string;
  name: string;
  fullUrl?: string;
  token?: string;
  headerFieldName?: string;
  headerFieldValue?: string;
}

export interface IOtpConfiguration {
    id: string;
    createdAt: Date;
    lastUpdatedAt: Date;
    name: string;
    subject: string;
    senderId: string;
    originatingNumber: string;
    originatingEmail: string;
    clientId: string;
    deleveryChannel: number;
    deleveryChannels: number[];
    customerificationMessage: string;
    otpType: number;
    createdOn: Date;
    expiresTime: number;
    otpLenght: number;
    fullUrl: string;
    token: string;
    headerFieldName: string;
    headerFieldValue: string;
    updatedOn: Date;
}

